export default __webpack_public_path__ + "static/media/rosemary.b37db8cc.jpg";